import { render, staticRenderFns } from "./OwnMsg.vue?vue&type=template&id=a360606c"
import script from "./OwnMsg.vue?vue&type=script&lang=js"
export * from "./OwnMsg.vue?vue&type=script&lang=js"
import style0 from "./OwnMsg.vue?vue&type=style&index=0&id=a360606c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports